export default {
taskRecord: {
  title: "कार्य पुरस्कार",
  loading: "लोड हो रहा है...",
  empty: "कोई कार्य पुरस्कार नहीं",
  completed: "यह कार्य पूरा हो चुका है",
  desc: "कार्य पूरा करने पर पुरस्कार मिलेगा",
  close: "बंद करें",
  add: "जोड़ें",
  addEmail: "ईमेल जोड़ें",
  addPhoneNumber: "फ़ोन नंबर जोड़ें",
  addBirthday: "जन्मदिन जोड़ें",
  downloadNow: "अभी डाउनलोड करें",
  phone: "फ़ोन नंबर",
  email: "ईमेल पता",
  bank: "बैंक कार्ड",
  birthday: "जन्मदिन",
  download: "डाउनलोड",
  downloadApp: "APP डाउनलोड करें",
  registerBonus: "पंजीकरण बोनस",
  firstInviteBonus: "पहला निमंत्रण बोनस",
  invite: "आमंत्रित करें",
  inviteNow: "मित्रों को आमंत्रित करें",
  go: "जाएं",
  receive: "प्राप्त करें",
  received: "प्राप्त हो चुका",
  task: "कार्य",
  claimRewards: 'इनाम दावा करें',
  receiveSuccess: 'इनाम सफलतापूर्वक प्राप्त हुआ',
  receiveFail: 'इनाम प्राप्त करने में विफल'
}
};
